import React, { createContext, ReactNode, useEffect, useState } from 'react';
import BackdropSpinner from '../components/BackdropSpinner';
import { reducerEndEvent, reducerStartEvent } from '../hooks/useAsyncReducer';

const voidFn = () => {
	return;
};

export const LoadingContext = createContext({
	isLoading: false,
	showLoading: voidFn,
	hideLoading: voidFn,
	resetLoadingSequences: voidFn,
});

// Loading spinner overlay provider, supporting simultaneous loading sequences
const LoadingProvider = ({ children }: { children: ReactNode }) => {
	useEffect(() => {
		// Listen for events fired at the beginning and end of reducers
		window.addEventListener(reducerStartEvent, showLoading);
		window.addEventListener(reducerEndEvent, hideLoading);
		return () => {
			window.removeEventListener(reducerStartEvent, showLoading);
			window.removeEventListener(reducerEndEvent, hideLoading);
		};
	}, []);

	// How many loading sequence 'events' are currently happening
	const [loadingSequences, setLoadingSequences] = useState<number>(0);
	const isLoading = loadingSequences > 0;

	// Add/remove loading sequence to stack
	const showLoading = () => setLoadingSequences((prevCount) => prevCount + 1);
	const hideLoading = () =>
		setLoadingSequences((prevCount) => (prevCount > 0 ? prevCount - 1 : 0));

	const resetLoadingSequences = () => setLoadingSequences(0);
	return (
		<>
			{loadingSequences > 0 && <BackdropSpinner />}
			<LoadingContext.Provider
				value={{
					isLoading,
					showLoading,
					hideLoading,
					resetLoadingSequences,
				}}
			>
				{children}
			</LoadingContext.Provider>
		</>
	);
};

export default LoadingProvider;
